import './base/';
import './select/select-handle'
import './popups/subscribe-popup'
import './popups/size-guide'
import './utilities/is-touch';
import './utilities/responsive-images';
import './cart/cart';
import './cart/cart-utils';
import './currency/currency-switcher';
import './sliders/product-slider';
import './sliders/slider-collection';
import './product/ajax-actions';
import './product/quantity';
import './product/variant-change';
import './accordion/accordions';
import './polyfills/object-fit';
import './header/header'
import {mailchimp} from './mailchimp/mailchimp';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed

mailchimp('.footer .subscribe form');
mailchimp('.popup-subscribe form');
